module.exports = __webpack_public_path__ + "img/logo-platezhnye-sistemy-qiwi.6824226.jpg";